import type { ReactNode } from 'react';

import PublicBatteryFlagsmithProvider from './PublicBatteryFlagsmithProvider';
import PublicRetrofitRolloutGate from './PublicRetrofitRolloutGate';

export default function PublicBatteryEcommBoundary({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <PublicRetrofitRolloutGate>
      <PublicBatteryFlagsmithProvider>
        {children}
      </PublicBatteryFlagsmithProvider>
    </PublicRetrofitRolloutGate>
  );
}
